import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import type { Connector } from 'react-redux'
import type { Store } from 'types/index'

import './styles.css'

const createBody = {
   name: "The Sovereign Individual",
   description: "Mastering the Transition to the Information Age",
   'local_price': {
       amount: "100.00",
       currency: "USD"
   },
  "pricing_type": "fixed_price",
   metadata: {
     "customer_id": "id_1005",
     "customer_name": "Satoshi Nakamoto"
   }
}

const createHeaders = {
  'user-agent': 'Mozilla/4.0 MDN Example',
  'X-CC-Api-Key': '573c1d98-691e-436b-a505-5837cb5b073b',
  'X-CC-Version': '2018-03-22',
  'content-type': 'application/json'
}

class ApiTest extends PureComponent {
  createCheckout = () => {
    console.log('createCheckoutClicked')

    fetch('https://api.commerce.coinbase.com/charges', {
      body: JSON.stringify(createBody),
      headers: createHeaders,
      method: 'POST',
    })
    .then(resJSON => resJSON.json())
    .then(res => console.log(res))
  }

  render(){
    return <fb>
      <fb className="createCheckout" onClick={this.createCheckout}>createCheckout</fb>
    </fb>
  }
}

const actionsToProps = {

}

const mapStateToProps = (state: Store) => ({

})

const connector: Connector<{}, Props> = connect(mapStateToProps, actionsToProps)
export default connector(ApiTest)



// WEBPACK FOOTER //
// ./src/containers/app/apiTest/index.js